import { injectable } from "inversify";
import ReportRepository, { GetUserReportResponse } from "../../../domain/repositories/ReportRepository";
import { Either, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import { UserType } from "../../../domain/entities/UserEntity";
import getUserReportApiIpml from "./api/GetUserReportApiImpl";

@injectable()
class ReportRepositoryImpl implements ReportRepository {
    getUserReport = async (_: {
        userId: String,
        role: UserType,
        startDate: Date,
        endDate: Date,
    }): Promise<Either<ErrorEntity, GetUserReportResponse>> => getUserReportApiIpml(_);
}

export default ReportRepositoryImpl;